import './sass/about.scss';
import { motion } from "framer-motion";
import { getSectionAnimation } from '../animations/sections';

function About() {
  const skills = [
    'Python',
    'Django',
    'Django Rest Framework',
    'JavaScript',
    'ReactJS',
    'Linux',
    'Docker',
    'Ansible',
    'MySQL',
    'MongoDB',
  ];
  
return (
<motion.section id="about" className="about" {...getSectionAnimation}>
        <h2 className="numbered-heading">About Me</h2>
        <div className="about-inner">
          <div className="about-info">
            <p>
            As a computer science graduate, I am deeply committed to the open-source community.
            My enthusiasm for technology and my dedication to collaborative innovation drive my work.
            With a background in computer engineering and hands-on industry experience, I bring a distinct
            skill set to every project. Known for my knack for solving complex problems with inventive solutions,
            my focus is on enhancing efficiency and amplifying the influence of open-source technology.
            </p>

            <p className="fw-bold">Skills</p>
            <ul className="skills-list">
              {skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>
          </div>
          <div className="about-pic">
            <div className="wrapper">
              <img src="profile-pic.jpg" width="500" height="500" alt="profile-pic" />
              <div className="box"></div>
            </div>
          </div>
        </div>
</motion.section>
);
}
export default About;
